import React from 'react'
import filter from 'lodash/filter'
import MaskedInput, { conformToMask } from 'react-text-mask'
import { usePrevious } from '../../../../../hooks/usePrevious'

export function TextMaskCustom(props) {
  const maskRef = React.useRef(null)
  const { inputRef, mask, ...other } = props
  const prevValue = usePrevious(props.value)

  const placeholderChar = React.useMemo(() => {
    let isHaveUnderline = Boolean(filter(mask, (v) => v === '_').length > 0)
    return isHaveUnderline ? '\u2000' : '_'
  }, [mask])

  React.useEffect(() => {
    //current value !== prev value => apply mask and call onChange
    const safeMask = mask.slice(0, String(props.value).length - 1)
    let nextVal = conformToMask(props.value, safeMask, { guide: false, placeholderChar })
    if (
      String(props.value).indexOf(nextVal.conformedValue) === -1 &&
      maskRef.current &&
      props.value &&
      prevValue !== props.value
    ) {
      let nextVal = conformToMask(props.value, mask, { guide: false, placeholderChar })
      if (nextVal.conformedValue !== props.value && typeof props.onChange === 'function') {
        props.onChange({
          target: {
            value: nextVal.conformedValue,
          },
        })
      }
    }
  }, [props.value])

  return (
    <MaskedInput
      {...other}
      mask={mask}
      ref={(ref) => {
        maskRef.current = ref
        inputRef(ref ? ref.inputElement : null)
      }}
      guide={false}
      placeholderChar={placeholderChar}
      allowedDecimalSeparators={[',', '.']}
      showMask
    />
  )
}
